import { createContext, Dispatch, ReactNode, useContext, useState } from "react"

interface AttractionContextInterface {
  value: string[]
  setValue: Dispatch<React.SetStateAction<string[]>>
  searchVal: string
  setSearchVal: Dispatch<React.SetStateAction<string>>
  searchActive: boolean
  setSearchActive: Dispatch<React.SetStateAction<boolean>>
}

export const AttractionContext = createContext({} as AttractionContextInterface)

export const AttractionProvider = ({ children }: { children: ReactNode }) => {
  const [value, setValue] = useState<string[]>([])
  const [searchVal, setSearchVal] = useState("")
  const [searchActive, setSearchActive] = useState(false)

  return (
    <AttractionContext.Provider
      value={{
        value,
        setValue,
        searchVal,
        setSearchVal,
        searchActive,
        setSearchActive,
      }}
    >
      {children}
    </AttractionContext.Provider>
  )
}

// eslint-disable-next-line react-refresh/only-export-components
export function useAttractionContext() {
  const appContext = useContext(AttractionContext)
  if (appContext === undefined) {
    throw new Error(
      "useAttractionContext must be used within an AttractionProvider"
    )
  }
  return appContext
}
